import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
    ref,
    Ref,
    ComputedRef,
    computed,
    watch
  } from 'vue'

  // Components
  import Input from './Input.vue'

  //Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  interface AttributeConfig {
    dot: boolean | string
    highlight: boolean | string
  }

  // Props
  interface Props {
    date: string
    error?: string
    showError?: boolean
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    date: {},
    error: {},
    showError: { type: Boolean }
  },
  emits: ["dateChange"],
  setup(__props: any, { emit: __emit }) {

  // Vue
  const store = useStore()

  // Translations
  const { t, d } = useI18n()

  // VCalendar
  const props = __props

  // Emit
  const emit = __emit

  // Refs
  const date: Ref<string> = ref(props.date)

    
    const masks = ref({
      modelValue: 'YYYY-MM-DD',
    });

  // Computed
  const locale = computed<string>(() => {
    // Fetching and processing locale
    const rawLocale = store.getters.getLocale || 'en' // Default to 'en' if not set
    const currentLocale = rawLocale.split('-')[0] // Extract the language code (e.g., 'fr' from 'fr-FR')
    return currentLocale
  })

  const validateDateFormat = (value: string): boolean => {
    const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/; // YYYY-MM-DD format
    return dateRegex.test(value)
  }

// Methods
const onDateChange = (): void => {
  console.log("date.value: ",date.value)
  if (validateDateFormat(date.value)) {
    emit("dateChange", date.value); // Emit the event if the date is valid
  } else {
    console.error("Invalid date format. Please use YYYY-MM-DD.");
  }
};



return (_ctx: any,_cache: any) => {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createBlock(_component_VDatePicker, {
    modelValue: date.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
    modelModifiers: { string: true },
    locale: locale.value,
    masks: masks.value,
    "max-date": new Date(),
    mode: "date",
    onDayclick: onDateChange
  }, {
    default: _withCtx(({ inputValue, inputEvents }) => [
      _createVNode(Input, {
        "input-styles": { cursor: 'pointer !important' },
        focused: "",
        readOnly: "",
        value: inputValue,
        label: _unref(t)('travellers.age'),
        inputEvents: inputEvents,
        error: _ctx.error,
        "show-error": _ctx.showError,
        inputType: "text"
      }, null, 8, ["value", "label", "inputEvents", "error", "show-error"])
    ]),
    _: 1
  }, 8, ["modelValue", "locale", "masks", "max-date"]))
}
}

})